import { DataAccessService } from '../../core/api';

export async function getRuleConfigs() {
  const client = new DataAccessService({
    baseURL: `/api`,
  });

  return await client.get(`/ruleconfigs`);
}
